import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";

export default function ModalInfoVersteuerndesHaushaltseinkommen() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1>Welchen Vorteil hat Einkommen unter 40.000 €?</h1>
            <p>Den Einkommens-Bonus gibt es nur für selbstnutzende Wohneigentümer mit durchschnittlichem, zu versteuernden Haushaltseinkommen von bis zu 40.000 € pro Jahr, nachgewiesen über die letzten beiden vorliegenden Einkommenssteuerbescheide aller Personen, die zum versteuernden Haushaltsjahreseinkommen beitragen.</p>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

